import { client as apolloClient } from '@xbcb/apollo-client';
import {
  LinkBasedS3Uploader,
  LinkGenerationFunction,
  recordSizeThresholdConfigMap,
} from '@xbcb/record-dao';
import { LargePayloadClient } from '@xbcb/schema-transformer/dist/largePayloadUtils/largePayloadClient';
import { UsDrawbackClaimS3Saver } from '@xbcb/schema-transformer/dist/largePayloadUtils/usDrawbackLargePayloadUtils/usDrawbackS3Saver';
import {
  LargeDrawbackClaimSavedFields,
  UsDrawbackClaimMutationInput,
} from '@xbcb/schema-transformer/dist/largePayloadUtils/usDrawbackLargePayloadUtils/types';
import { RecordType } from '@xbcb/shared-types';
import { createWorkOrderPresignedUrlGqlString } from '../uiUsConsumptionEntryLargeEntryClient/createWorkOrderPresignedUrl.query';

const s3LinkGenerationFunction = (async () => {
  const response = await apolloClient.mutate({
    mutation: createWorkOrderPresignedUrlGqlString,
  });
  return response.data.createWorkOrderPresignedUrl;
}) as LinkGenerationFunction;

const uploadFunction = async (
  uploadLink: string,
  content: BodyInit | null | undefined,
) => {
  return fetch(uploadLink, {
    method: 'PUT',
    body: content,
    headers: {
      'Content-type': 'application/octet-stream',
    },
  });
};

const frontendS3Uploader = new LinkBasedS3Uploader(
  s3LinkGenerationFunction,
  uploadFunction,
);

/**
 * Frontend large payload client for US Drawback Claims.
 * Uses Apollo client to generate presigned S3 upload URLs and fetch to upload.
 * Offloads large fields (imports, TFTEAExportDestroyArticles, cbpRejectionReasons,
 * matchPairs) to S3 when the payload exceeds DDB size thresholds.
 */
export class UiUsDrawbackClaimLargePayloadClient extends LargePayloadClient<
  LargeDrawbackClaimSavedFields,
  UsDrawbackClaimMutationInput
> {
  constructor() {
    super(
      new UsDrawbackClaimS3Saver(frontendS3Uploader),
      (referenceKey, input) => {
        input.drawbackClaimReference = referenceKey;
        return input;
      },
      recordSizeThresholdConfigMap[RecordType.US_DRAWBACK_CLAIM],
      true,
    );
  }
}

let frontendClient: UiUsDrawbackClaimLargePayloadClient;

export const getFrontendUsDrawbackClaimLargePayloadClient =
  (): UiUsDrawbackClaimLargePayloadClient => {
    if (frontendClient === undefined) {
      frontendClient = new UiUsDrawbackClaimLargePayloadClient();
    }
    return frontendClient;
  };
